import React, { useRef } from "react";
import {
  Button,
  NewInputList,
  NewInputListHandles,
  NewSelectList,
  NewCreatableSelect,
  NewModal,
  MainContentPaddingTypes,
  NewSelectListHandles,
  NewCreatableSelectList,
  NewSelectHandles,
} from "../../Components";
import { ListStyle_Types } from "../../Definitions";
import { useTranslation } from "react-i18next";
import { DynamicDataObk } from "../../Services";
import { CreatePanelDevice } from "../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/GQLCalls/maintainDeviceInfoCall";
import { useLcIoOptions } from "../../Containers/CloudScreens/GlobalScreens/Settings/_Settings/useLcIoOptions";

interface addIoModalProps {
  isModalOpen: boolean;
  closeModal: () => void;
  maintainDeviceInfo?: (
    changed?: Partial<DynamicDataObk<any>> | Partial<DynamicDataObk<any[]>>,
    deleted?: Partial<DynamicDataObk<any>> | Partial<DynamicDataObk<any[]>>,
    created?: Partial<DynamicDataObk<any>> | Partial<DynamicDataObk<any[]>>
  ) => void;
}

export default function AddIoModal({
  isModalOpen,
  closeModal,
  maintainDeviceInfo,
}: addIoModalProps) {
  const { t } = useTranslation();

  const inputRef = useRef<NewInputListHandles>(null);
  const selectsRef = useRef<NewSelectListHandles>(null);
  const creatableSelectRef = useRef<NewSelectHandles>(null);

  const handleCreate = () => {
    const createdDevice: CreatePanelDevice = {};

    if (inputRef && inputRef.current && inputRef.current.refs.current) {
      createdDevice.name = inputRef.current.refs.current[0].value.toString();
      createdDevice.power_supply = +inputRef.current.refs.current[1].value;
      createdDevice.max_ac_ports = +inputRef.current.refs.current[2].value;
    }
    if (creatableSelectRef && creatableSelectRef.current) {
      createdDevice.cpu_id =
        creatableSelectRef.current.value.label ?? undefined;
    }
    if (selectsRef && selectsRef.current && selectsRef.current.refs.current) {
      createdDevice.lan_controller_id = selectsRef.current.refs.current[0]?.value
        .id
        ? +selectsRef.current.refs.current[0]?.value.id
        : undefined;
      createdDevice.system_assignment = selectsRef.current.refs.current[1]?.value
        .id
        ? +selectsRef.current.refs.current[1]?.value.id
        : undefined;
    }

    if (inputRef && inputRef.current) {
      if (!createdDevice.name) {
        inputRef.current.refs.current[0].setError();
        return;
      }
      if (!createdDevice.power_supply) {
        inputRef.current.refs.current[1].setError();
        return;
      }
      if (!createdDevice.max_ac_ports) {
        inputRef.current?.refs.current[2].setError();
        return;
      }
      if (maintainDeviceInfo) {
        maintainDeviceInfo({ data: [createdDevice] });
        closeModal();
      }
    }
  };

  const { systemOptions, lanControllerOptions, deviceCpuOptions } =
    useLcIoOptions();

  return (
    <NewModal
      header={t("devices.newIoBoard", { defaultValue: "new I/O board" })}
      modalState={isModalOpen}
      predefinedButtons={{
        onClose: closeModal,
      }}
      overrides={{
        mainContentPadding: MainContentPaddingTypes.secondary,
      }}
      mainContent={
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "60px",
            marginTop: "25px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <NewInputList
              ref={inputRef}
              headers={[
                t("devices.boardName", { defaultValue: "board name" }),
                t("devices.powerSupply", { defaultValue: "power supply" }),
                t("devices.maxAcPorts", { defaultValue: "max ac ports" }),
              ]}
              placeholders={["", "", ""]}
              isRequired={[true, true, true]}
              listOverrides={{
                listStyle: ListStyle_Types.vertical,
                listGap: "10px",
              }}
            />
            <NewCreatableSelect
              ref={creatableSelectRef}
              isSearchable
              header={t("devices.cpuId", { defaultValue: "cpu id" })}
              options={deviceCpuOptions}
            />
            <NewSelectList
              ref={selectsRef}
              headers={[
                t("devices.connection", { defaultValue: "connection" }),
                t("devices.system", { defaultValue: "system" }),
              ]}
              placeholders={["", ""]}
              options={[lanControllerOptions, systemOptions]}
              isRequired={[false, false]}
              listOverrides={{
                listStyle: ListStyle_Types.vertical,
                listGap: "10px",
              }}
            />
          </div>
          <Button
            content={t("buttons.create", { defaultValue: "create" })}
            onClick={handleCreate}
          />
        </div>
      }
    />
  );
}
